import { drawer } from "./_drawer";
import { animation } from "./_animation";
import { agent } from "./_agent";

drawer();
animation();
agent();
